<template>
  <div class="form-group form-label">
    <div class="col-md-12">
      <div class="row">
        <div :class="`col-md-${this.col1}`">
          <label>{{this.label}}</label>
        </div>
        :
        <div :class="`col-md-${this.col2}`">
          <span>{{this.text}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['label', 'text', 'col1', 'col2']
}
</script>